<template>
    <div class="form-despesa-filho">
        <div class="actions">
            <a href="#" class="text-primary" @click.prevent="$emit('delete', formacao)" v-show="despesa.despesa_educacao_filho_id">
                <i class="material-icons">delete</i>
            </a>
        </div>
        <div class="mb-5">
            <h6 class="text-primary despesa-filho-titulo"  :class="{disabled: !despesa.despesa_educacao_filho_id}">{{ formacao.nome }}</h6>
            <label>{{ formacao.descricao || "&nbsp;" }}</label>
        </div>
        <div>
            <label>CUSTO MENSAL</label>
            <div class="input-money">
                <money min="0" type="text" step="0.01" class="form-control" v-model="despesa.custo_mensal" :class="{'with-validation' : incompleto(despesa) }"/>
            </div>
            <div :style="{visibility: incompleto(despesa) ? 'visible' : 'hidden'}" class="mb-3 red-text">
                <small>Campo obrigatório</small>
            </div>
        </div>

        <div>
            <label>ANOS RESTANTES</label>
            <input type="number" class="form-control" v-model.number="despesa.anos_restantes" min="0">
        </div>

        <div>
            <label>MESES RESTANTES</label>
            <input type="number" class="form-control" v-model.number="despesa.meses_restantes" min="0" max="11">
        </div>

        <div>
            <label>TOTAL</label>
            <div class="grey-text">
                <strong>{{ total | dinheiro }}</strong>
            </div>
        </div>
    </div>
</template>


<script>
import debounce from "lodash/debounce";


export default {

    name: 'form-despesa-filho',

    props: {
        value: Object,
        formacao: Object,
    },

    computed: {

        meses() {

            const anos = this.despesa.anos_restantes || 0;
            const meses = this.despesa.meses_restantes || 0;

            return meses + (anos * 12);

        },

        total() {

            const total = this.meses * this.despesa.custo_mensal

            return isNaN(total) ? 0 : total;
        }
    },

    data() {
        return {
            despesa: {}
        }
    },

    methods: {
        incompleto(despesa) {
            return !despesa.custo_mensal && (despesa.anos_restantes || despesa.meses_restantes)
        },
        validar(despesa) {
            return despesa.custo_mensal && (despesa.anos_restantes || despesa.meses_restantes);
        }
    },


    watch: {
        despesa: {
            deep: true,
            handler: debounce(function(despesa) {
                if (this.validar(despesa)) {
                    this.$emit('input', despesa);
                }

            }, 500)
        },

        value: {
            deep: true,
            handler(value) {
                this.despesa = value;
            }
        }
    }
}
</script>



<style lang="scss">
.despesa-filho-titulo{
    font-size: 18px;
    margin: 0;
}

.disabled{
    filter: grayscale(100%);
}

.form-despesa-filho{
    transition: all 500ms ease;
    position: relative;

    .actions{
        position: absolute;
        right: 0;
        top: 0;
        margin-right: 15px;
        margin-top: 15px;
    }
}


.form-control.with-validation{
    border-bottom-color: red !important;
}
</style>


<style lang="scss" scoped>
.input-money{
    .form-control{
        margin-bottom: 0;
    }


    &::before{
        top: 50%;
        // transform: translateY(0);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/common/FormDespesaFilho.vue